import { ReactComponent } from "./circle-close-fill.svg";

const CircleCloseFillIcon = () => <ReactComponent />;

export default CircleCloseFillIcon;
